import Menu from './Menu';
import Logo from './Logo';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useEffect,useState } from 'react';
import Banner from '../ListGroups/Banner';
import { DefaultBanner } from '../ListGroups/Banner';
import { BANNER_OVERLAY } from '../designTokens';

const useStyles = makeStyles({
    Banner: {
        height: "550px",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "scroll",
        backgroundSize: "cover",
    }
});


const DesktopHeader = () => {
    const classes = useStyles();
    const location = useLocation();
    const [bannerObj,setBannerObj] = useState({...DefaultBanner})
    useEffect(()=>{
        if(Banner[location.pathname]){
            setBannerObj({...Banner[location.pathname]});
        }
        else{
            setBannerObj({...DefaultBanner});
        }
    },[location]);
    return (
        <>
            <header className="header header--desktop">
                <Logo />
                <Menu />
            </header>
            <article
                style={{
                    marginBottom: "8px",
                    background: bannerObj.solidBackground || !bannerObj.backgroundUrl
                        ? BANNER_OVERLAY
                        : `${BANNER_OVERLAY}, url(${bannerObj.backgroundUrl})`,
                }}
                className={classes.Banner}
            >
                <Grid container alignItems="center" style={{ height: "100%" }}>
                    <Grid item style={{ marginLeft: "auto", marginRight: "auto" }} lg={8}>
                        {
                            bannerObj.backgroundDescriptions.map(function(el){
                                return (
                                    <h2 className="text-white header-banner-text" style={el.style}>{el.text}</h2>
                                )
                            })
                        }
                    </Grid>
                </Grid>
            </article>
        </>
    );
}

export default DesktopHeader;